<template>
<div class="form-row">
    <div class="col-5">
        <form-input :label="employeeContributionLabel" placeholder="e.g. 3%" v-model="formData.employee_contribution" @update="$emit('update', this.modelValue)" :errors="errors.employee_contribution" type="integer-string" />
    </div>

    <div class="col-5">
        <form-input label="Employer will match (%)" placeholder="e.g. 100%" v-model="formData.employer_match" @update="$emit('update', this.modelValue)" :errors="errors.employer_match" type="integer-string" />
    </div>

    <div class="col-1">
        <a v-if="showRemove" href class="btn btn-outline-primary" @click.prevent="$emit('remove')">X</a>
    </div>
</div>
</template>

<script>
import FormMixin from '@/mixins/Form'

export default {
    props: ['employeeContributionLabel', 'showRemove', 'modelValue'],
    mixins: [FormMixin, ],
    emits: ['remove', 'update:modelValue'],
    data() {
        return {
            errors: {},
            formData: this.makeFormData(),
            formRules: {
                employee_contribution: {presence: {allowEmpty: false}, numericality: {onlyInteger: true, greaterThanOrEqualTo: 0, lessThanOrEqualTo: 100}},
                employer_match: {presence: {allowEmpty: false}, numericality: {onlyInteger: true, greaterThanOrEqualTo: 0, lessThanOrEqualTo: 100}},
            },
        }
    },
    computed: {
        company() {
            return this.client.companies.find(c => c.id == this.plan.company_id)
        },
    },
    methods: {
        makeFormData() {
            return {
                employee_contribution: this.modelValue.employee_contribution ? this.modelValue.employee_contribution : '',
                employer_match: this.modelValue.employer_match ? this.modelValue.employer_match : '',
            }
        },
    },
}
</script>
